// extracted by mini-css-extract-plugin
export default {"container":"ResourceImagePlaceHolder__container___zBQoz","imageContainer":"ResourceImagePlaceHolder__imageContainer___NQQuO","text":"ResourceImagePlaceHolder__text___hf5PW"};